import { render, staticRenderFns } from "./UnsupportedBrowserModal.vue?vue&type=template&id=4380e807&scoped=true"
import script from "./UnsupportedBrowserModal.vue?vue&type=script&lang=js"
export * from "./UnsupportedBrowserModal.vue?vue&type=script&lang=js"
import style0 from "./UnsupportedBrowserModal.vue?vue&type=style&index=0&id=4380e807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4380e807",
  null
  
)

export default component.exports